module.exports = __webpack_public_path__ + "static/media/nordic_oak.e7016b24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interiorColors/nordic_oak.jpg
// module id = 38
// module chunks = 0